import Masthead from "@/pages/home/components/Masthead";
import Hero from "@/pages/home/components/Hero";
import NewFaces from "@/pages/home/components/NewFaces";
import Stream from "@/pages/home/components/Stream";
import DeepDive from "@/pages/home/components/DeepDive";
import RankBoard from "@/pages/home/components/RankBoard";
import Sectors from "@/pages/home/components/Sectors";
import DownloadCta from "@/pages/home/components/DownloadCta";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <Masthead />
      <main>
        {/* 首屏：多卡并列 · 杂志封面阅读感 */}
        <Hero />
        {/* 新涉事者聚焦：新面孔档案 */}
        <NewFaces />
        {/* 快讯流：时间线还原关键时点 */}
        <Stream />
        {/* 事件还原：长读档案 */}
        <DeepDive />
        {/* 热议榜：近24h人物热度 */}
        <RankBoard />
        {/* 栏目分区：厚运营壳强分区 */}
        <Sectors />
        {/* 入口/下载醒目 CTA */}
        <DownloadCta />
      </main>
      <Footer />
    </div>
  );
}